export const LOAD_MERCHANT_APPLICATION = 'LOAD_MERCHANT_APPLICATION';
export const SET_MERCHANT_APPLICATION_PROCESSING_VOLUME =
  'SET_MERCHANT_APPLICATION_PROCESSING_VOLUME';

export const setMerchantApplicationProcessingVolume = processingVolumes => ({
  type: SET_MERCHANT_APPLICATION_PROCESSING_VOLUME,
  processingVolumes
});

export const loadMerchantApplication = () => ({
  type: LOAD_MERCHANT_APPLICATION
});

const initialState = { loading: true, merchantApplication: {} };
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MERCHANT_APPLICATION_PROCESSING_VOLUME:
      return {
        ...state,
        processingVolumes: action.processingVolumes,
        loading: false
      };
    default:
      return state;
  }
};
